const lang = {
  developmentAndDeploymentChecklist: 'Development, Deployment and Publishing Checklist',
  developmentAndDeploymentChecklistInfo: 'Below is the checklist that needs to be fulfilled prior to deployment. You can tick any step that you have performed in order to keep track of your work.',
  developmentAndDeploymentChecklistSuccess: 'Success. Your checklist is all done.',
  themeColorsCreator: 'Theme Colors Creator',
  getColorScheme: 'Get Color Scheme',
  createThemeColors: 'Generate Random Theme Colors',
  colorMode: 'Select mode by which to generate the scheme from the seed color',
  seedColor: 'Use color picker to choose seed color',
  expanded: 'Expanded',
  details: 'Details',
  released: 'Released',
  component: 'Component',
  decreaseBrightness: 'Decrease Brightness',
  increaseBrightness: 'Increase Brightness',
  brightness: 'Brightness',
  testTheExpandProp: 'Test the component\'s expand prop',
  toggleSelectionBtn: 'Selection Button',
  showFretNumber: 'Fret number',
  chordName: 'Chord name',
  showPositions: 'Show positions',
  autoHide: 'Auto Hide',
  chordDescription: 'Chord description',
  internetConnection: 'Internet Connection',
  submit: 'Submit',
  magnification: 'Magnification',
  jump: 'Jump!',
  visible: 'Visible',
  clearLog: 'Clear Log',
  visibilityLogger: 'Visibility Logger',
  visibilityLoggerInstructions: 'Open your browser\'s console, switch to another tab then come back here to see some changes.',
  openAppIndicators: 'Show Indicators for Open Applications',
  myJsonSchemaForm: 'My JSON Schema Form',
  pickABcqComponent: 'Pick a BCQ UI Component',
  startTyping: 'Start typing and hit enter...',
  pickAMonth: 'Pick a Month',
  fuzzySearch: 'Fuzzy Search',
  reset: 'Reset',
  inline: 'Inline',
  prefix: 'Prefix',
  postfix: 'Postfix',
  nextPage: 'Next page',
  previousPage: 'Previous page',
  toolbar: 'Toolbar',
  spellCheck: 'Spell Check',
  headers: 'Headers',
  connectionSpeed: 'Connection Speed',
  deviceEmulator: 'Device Emulator',
  footers: 'Footers',
  dimensions: 'Dimensions',
  zoom: 'Zoom',
  selectAll: 'Select all',
  customButton: 'Custom Button',
  customContent: 'Custom content in the default Vue slot. You can add virtually anything here, including text, HTML or Vue components',
  yourFavoriteGuitarists: 'Your Favorite Guitarists',
  ourFavoriteGuitarists: 'Our Favorite Guitarists',
  noClamping: 'No clamping',
  legend: 'Legend',
  selectionTypeLabel: 'Selection Type Label',
  endless: 'Endless',
  dots: 'Dots',
  count: 'Count',
  externalControl: 'External Control',
  autoplay: 'Autoplay',
  clickToExpandCollapse: 'Click to expand/collapse',
  typeSomeTextAndHitEnter: 'Type some text...',
  spinButtons: 'Spin buttons',
  backdropBlur: 'Backdrop Blur',
  reversed: 'Reversed',
  scrollToTop: 'Scroll to top',
  clickToCopy: 'Click to copy',
  positiveElevation: 'Positive Elevation',
  negativeElevation: 'Negative Elevation',
  repository: 'Repository',
  nightShift: 'Nightshift',
  aspectRatio: 'Aspect Ratio',
  typeAndHitEnter: 'Type and hit enter...',
  showButton: 'Show Button',
  cover: 'Cover',
  downloadQrCode: 'QR Code',
  separator: 'Separator',
  buttons: 'Buttons',
  label: 'Label',
  rounded: 'Rounded',
  multiline: 'Multiline',
  downloadSocialServicesJsFile: 'Download Services File',
  allowedMimeTypes: 'Allowed mime-types:',
  maxFileSize: 'Max file-size',
  ticks: 'Ticks',
  tickFractions: 'Tick Fractions',
  labels: 'Labels',
  step: 'Step',
  useRibbonTool: 'use ribbon tool',
  command: 'Command',
  clickRibbonTab: 'click ribbon tab',
  showDialog: 'Show Dialog',
  fancy: 'Fancy',
  fileFolderStructure: 'Project File and Folder Structure',
  flexColumns: 'Flex Columns',
  breakpoints: 'Breakpoints',
  clickMeForRipple: 'Click to See the Ripple Effect',
  multiple: 'Multiple',
  downloadBcqUi: 'BCQ UI',
  addNewNotification: 'Show Notification',
  flexModifiers: 'Modifier Attributes',
  flexModifiersInfo: 'You can apply the flex modifier attributes to change the size of a <code>flex-col</code> depending on the current breakpoint.',
  resizeTheWindowFlex: 'Resize the window to see breakpoints kicking-in',
  complexLayous: 'Complex Layouts',
  action: 'Action',
  text: 'Text',
  active: 'Active',
  browseCode: 'Browse Code on Bitbucket',
  viewPageOnBitbucket: 'Page',
  viewComponentOnBitbucket: 'Component',
  ribbonApi: 'Ribbon API',
  debug: 'Debug',
  setFontColor: 'Set "#4caf50" new value to the text-color picker in the "Font" ribbon',
  setBgColor: 'Set "#2196f3" new value to color to the highlight-color picker in the "Font" ribbon',
  setComicSansMS: 'Set "Comic Sans MS" value to the font dropdown in the "Font" ribbon',
  setFontSize: 'Set "22px" value to the font-size dropdown in the "Font" ribbon',
  selectCheckbox: 'Select unchecked checkbox in the "Checkboxes" ribbon',
  selectTS: 'Select the "TypeScript" radio in the "Editing" ribbon',
  setNumericInput: 'Set new value to the numeric input in the "Numeric Inputs" ribbon',
  ribbonApiInfo: 'The API enables the external communication (for example - from a WYSIWYG editor) with the ribbon and allows programmatic selection of dropdowns, checkboxes, radios, toggling of button groups (font-style, text-alignment, etc.), disabling tools and tool options, and setting values to the numeric inputs and color pickers via the props of the component. You can test these props below:',
  outlined: 'Outlined',
  darkLight: 'Dark / Light',
  prevNextButtons: 'Previous / Next',
  firstLastButtons: 'First / Last',
  previous: 'Previous',
  next: 'Next',
  toggleBoldAndUnderline: `Toggle the "bold" and "underline" buttons in the "font" ribbon`,
  setAlignCenter: `Set "align-center" in the "paragraph" ribbon`,
  expandCollapseIcon: 'Expand/collapse icon',
  defaultButton: 'Default Button',
  weUseCookies: 'We use cookies to ensure you get the best experience. Click the "policy" button to learn how we use the information we collect.',
  readonly: 'Readonly',
  hint: 'Hint',
  showRipple: 'Show Ripple',
  showFileIcon: 'File Icon',
  checkboxes: 'Checkboxes',
  goToBrandCompete: 'BrandCompete',
  buttonSizes: 'Button Sizes',
  linkButton: 'Link Button',
  routerLinkButton: 'Vue Router-Link Button',
  plain: 'Plain',
  searchComponent: 'Search for a component...',
  flat: 'Flat',
  search: 'Search',
  vertical: 'Vertical',
  testToolbarInfo: '* The configurator shows only the most important props of the component. Check the complete props, slots and events documentation at the bottom of the page',
  subTitle: 'Subtitle',
  configurator: 'Component Configurator',
  cardTitle: 'Card Title',
  dense: 'Dense',
  actions: 'Actions',
  menu: 'Menu',
  titleAndName: 'Title and Name',
  termsOfService: 'Terms of Service',
  buttonOpener: 'Open from Button',
  openFromAvatar: 'Open from Avatar',
  splitButton: 'Split Button',
  cancel: 'Cancel',
  createBundle: 'Create Bundle',
  customBuildBundler: 'Custom Build Bundler',
  ok: 'Ok',
  avatar: 'Avatar',
  title: 'Title',
  noIcon: 'Hide icon',
  chevron: 'Chevron',
  block: 'Block',
  onOff: 'On / off',
  code: 'Code',
  decrease: 'Decrease',
  increase: 'Increase',
  loading: 'Loading',
  iconLeft: 'Left icon',
  iconRight: 'Right icon',
  template: 'Template',
  script: 'Script',
  data: 'Data',
  asyncFormDemo: 'Demo of the async-form, using all of our form components',
  close: 'Close',
  submitForm: 'Submit',
  resetForm: 'Reset',
  receivePromoEmails: 'I agree to receive promo emails',
  agreeToProcessPersonalData: 'I agree to have my personal data processed',
  dismissible: 'Dismissible',
  agreeToTos: 'I agree to the Terms of Service',
  codeSamplesNotAdded: 'Code samples for this component have not been added yet. Working on it.',
  disabled: 'Disabled',
  selected: 'Selected',
  genericExamplesTitle: 'Examples, use cases, props, slots and events',
  underConstruction: 'This page is under construction or the component has not been developed yet. Stay tuned.',
  home: 'Home',
  theme: 'Dark',
  indeterminate: 'Indeterminate',
  tile: 'Tile',
  collapsed: 'Collapsed',
  floating: 'Floating',
  temporary: 'Temporary',
  documentationNotAddedYet: 'Documentation not added yet',
  codeSamplesNotAddedYet: 'Code samples not added yet',
  modal: 'Modal',
  dismissButton: 'Dismiss Button',
  icon: 'Icon',
  docs: 'Docs',
  clear: 'Clear',
  getHistory: 'Get History',
  error: 'Error',
  hintText: 'Hint text',
  required: 'Required',
  inputLabel: 'Input Label',
  inputPlaceholder: 'Input Placeholder',
  errorText: 'Error text',
  showLoadingOverlay: 'Show loading overlay',
  fullScreenLabel: 'Fullscreen',
  persistent: 'Persistent',
  right: 'Right',
  executeSampleCommand: 'Execute Sample Command',
  toggleNavigation: 'Toggle navigation',
  sitemap: 'Sitemap',
  iAmASnackbar: 'Hi, I am a snackbar!',
  clearable: 'Clearable',
  firstName: 'First name',
  lastName: 'Last name',
  password: 'Password',
  passwordRepeat: 'Repeat password',
  comments: 'Comments',
  downloadFlags: 'Flags',
  downloadBundle: 'Download Bundle',
  bcqUi: 'BCQ UI',
  bundle: 'Bundle',
  horizontal: 'Horizontal',
  galleryWithLazyImageAndDialog: 'Lightbox Gallery with Lazy Image and Dialog Box',
  mobileMessage: 'Although Becquerel UI fully supports mobile devices, in order to use this website as a development reference, it is recommended that you view it on your desktop.',
  paginationFilteringSorting: 'Pagination, Filtering and Sorting',
  lightsOut: 'Lights Out',
  transparent: 'Transparent',
  separators: 'Separators',
  controls: 'Controls',
  ripple: 'Ripple',
  colorPicker: 'Color Picker',
  dark: 'Dark',
  icons: 'Icons',
  leftClick: 'Left Click',
  rightClickOnTheImage: 'Right Click on the Image',
  capLine: 'Cap Line',
  directive: 'Directive',
  searchInAllColumns: 'Search in all columns...',
  sections: {
    'getting-started': 'Getting Started',
    'content': 'Content, Style and Color',
    'ui': 'UI Components',
    'forms': 'Form Components',
    'directives': 'Directives',
    'integrations': 'Integrations'
  },
  bundleCodeComments: `/**
 * this is your custom bundle for bc-becquerel
 * you need to replace
 * ~/node_modules/@brandcompete/bc-becquerel/src/bcq-ui/components/index.js
 * or
 * /bcq-ui/components/index.js with this one
 * and then include the library manually to your vue project
 * you can check the https://becquerel-test.brandcompete.com/getting-started/quick-start
 * to learn how to use becquerel-ui as download instead from npm
 * created on ${new Date()}
 */\n`,
  addRemoveFromBundle (selected) {
    return `Click to ${selected ? 'remove from' : 'add to'} bundle`
  },
  bundleDependencies (dependencies = []) {
    return `dependencies: <span class="opacity-50 font-bold">${dependencies.join(', ')}</span>`
  },
  unreadMessages (count = 10, type = 'messages') {
    return `${count} Unread ${type}`
  },
  browseForFile (type, multiple) {
    return `Browse for ${type} file${multiple ? 's' : ''}`
  },
  tooltip: (position) => {
    return `${position} tooltip`
  },
  notificationType: (type) => {
    return `${type} Notification`
  },
  notificationText: (type, persistent, slug, autoClose) => {
    return `I am a ${persistent ? 'persistent' : 'non-persistent'} ${type} notification. You ${persistent ? 'cannot' : 'can'} close me.${slug ? ' Yet, I am clickable via the <code class="font-bold">click</code> handler in the <code class="font-bold">items</code> object.' : ''}${autoClose ? ' I will auto close in ' + autoClose / 1000 + ' seconds as I have value of <code>' + autoClose + '</code> in my <code>item.autoClose</code> object.' : ''}`
  },
  documentationFor: (title) => {
    return `${title ? title + ' ' : ''}Props, Slots and Events`
  },
  providerIcons: (provider, count) => {
    return `${provider} (${count} icons)`
  },
  didYouSetMetaDataFile: (error, fullPath) => {
    return `<span class="text-red-500">${error}. Did you set meta data file in /STATIC_ASSETS_DIR/data${fullPath}?</span>`
  },
  fullScreen: (fullScreen) => {
    return `${fullScreen ? 'Exit fullscreen' : 'Fullscreen'}`
  },
  copiedToClipboard: (text) => {
    return `"${text}" copied to clipboard.`
  },
  switchTo: (color) => {
    return `Switch site to "${color}" color`
  },
  sectionTitle: (section, count = 0) => {
    return `${section} (${count} items)`
  },
  size: (size, units = 'px') => {
    return `${size}${units}`
  },
  goTo: (item) => {
    return `Go to ${item}`
  },
  episodes: (series, length, searchIn = 'name') => {
    return `${series} (${length} Episodes). ${searchIn === '__all__' ? 'Search in all columns ("' + searchIn + '")' : 'Search in "' + searchIn + '"'}`
  },
  toggleComponent: (hidden, component) => {
    return `${hidden ? 'Hide' : 'Show'} ${component}`
  },
  noSearchResultsFor (query = '') {
    return `No search results for "${query}". Try another search with different parameters.`
  },
  searchResultsFor (query = '', length = 0) {
    return `We found ${length} search results for your "${query}" query.`
  },
  event (number) {
    return `Event ${number + 1}`
  },
  theProp (prop) {
    return `The <code class="underline">${prop}</code> prop`
  },
  toggleDisabled (command, ribbon) {
    return `Toggle the disabled state of the "${command}" tool in the "${ribbon}" ribbon`
  },
  toggleToolItemDisabled (button, tool) {
    return `Toggle the disabled state of the "${button}" item in the the "${tool}" btn-group/menu-list/dropdown/quick-launch`
  },
  spread (value) {
    return `Spread ${value}`
  },
  ambience (value) {
    return `Ambience ${value}`
  },
  roundedLabel (value) {
    return `Rounded "${value}"`
  },
  legendAlign (value) {
    return `legend-align: ${value}`
  },
  contentAlign (value) {
    return `content-align: ${value}`
  },
  clampAt (value) {
    return `Clamp ${value} line${value === 1 ? '' : 's'}`
  },
  transferFooterSlot (shuttle = 'left') {
    return `The <code>v-slot:footer-${shuttle}</code> slot is just a container that you can use to put custom HTML, text or Vue components. For this demo, we added a "select/deselect all checkbox, but the content can be virtually anything."`
  },
  orientation (portrait) {
    return portrait ? 'Portrait' : 'Landscape'
  },
  internetConnectionText (online) {
    return `You are currently ${online ? 'online' : 'offline'}`
  }
}

export default lang



// WEBPACK FOOTER //
// ./src/helpers/lang.js